(function () {
	function init() {
		const nav = document.querySelector('#solution-nav');
		if (!nav) return;

		const links = nav.querySelectorAll('a');
		const tabs = document.querySelectorAll('.solutions-wrapper .solution-tab');
		if (!links.length || !tabs.length) return;

		// Move .active to the given tab and its matching nav link.
		// When syncUrl is true, reflect the choice in ?solution= so the
		// address bar stays shareable (other params + hash are preserved).
		function activate(target, syncUrl) {
			if (!target) return;
			links.forEach((l) => l.classList.toggle('active', l.getAttribute('href') === '#' + target.id));
			tabs.forEach((t) => t.classList.toggle('active', t === target));

			if (syncUrl && window.history.replaceState) {
				const params = new URLSearchParams(window.location.search);
				params.set('solution', target.id);
				const query = params.toString();
				window.history.replaceState(null, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
			}
		}

		// The nav is hidden below $tall, so these clicks only fire on tablet/desktop.
		nav.addEventListener('click', function (e) {
			const link = e.target.closest('a');
			if (!link || !nav.contains(link)) return;

			const id = link.getAttribute('href');
			if (!id || id.charAt(0) !== '#') return;

			const target = document.querySelector(id);
			if (!target) return;

			e.preventDefault();
			activate(target, true);
		});

		// Deep link: ?solution=practice-management selects that tab on load.
		const requested = new URLSearchParams(window.location.search).get('solution');
		if (requested) {
			const target = document.getElementById(requested);
			if (target && target.classList.contains('solution-tab')) {
				activate(target);
			}
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
